import React from 'react';
import NavbarHeaderIcon from '../../../assets/ad-thank-you/fibe-logo-header.png';

const TopNavbarHeader = () => {
  return (
    <div className="w-full bg-white h-12 md:h-16 flex justify-start items-center shadow-sm mb-4">
      <div className="bg-white rounded-[65%] p-6 ">
        <img className="m-3 mt-6 max-w-[60px]" src={NavbarHeaderIcon} />
      </div>
    </div>
  );
};

export default TopNavbarHeader;
